import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {}, //用户信息
    bookList: []
  },
  getters: {
    bookList: state => state.bookList
  },
  mutations: {
    chnageBookList(state, bookList) {
      state.bookList = bookList;
    }
  },
  actions: {},
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js